import React from 'react';

import { Typography } from '@mui/material';

import styled from '../../../../styled';
import { colorsPalette, SMALL_MARGIN_PX } from '../../../../theme';

interface CardDescriptionProps {
  text: string;
  className?: string;
}

const CardDescription: React.FC<CardDescriptionProps> = ({ text, className, ...rest }) => {
  return (
    <Description className={className} {...rest}>
      {text}
    </Description>
  );
};

export default CardDescription;

const Description = styled(Typography)`
  display: -webkit-box;
  font-size: 18px;
  line-height: 1.5;
  font-weight: normal;
  margin-bottom: ${SMALL_MARGIN_PX};
  color: ${colorsPalette.gray};
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  word-break: break-word;
`;
